import React from "react";

const Button = ({ text, onClick, type = "button", fullWidth = false, disabled = false }) => {
    return (
        <button
            type={type}
            onClick={disabled ? undefined : onClick}
            disabled={disabled}
            className={`${fullWidth ? "w-full" : "w-auto"
                } ${disabled 
                    ? "bg-gray-400 cursor-not-allowed" 
                    : "bg-[rgb(71,63,125)] hover:bg-[rgb(71,63,125,0.8)]"
                } text-white px-6 py-4 rounded-[4px] text-[16px] transition mt-4 font-['ArchivoExpandMid']`}
        >
            {text}
        </button>
    );
};

export default Button;
